let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("tzYS3")).then(() => parcelRequire('aEKbH'));